export default __webpack_public_path__ + "static/Asset 12@300x-02b2913059e2882764fefc996890ec84.png";